import { useEffect, useState } from 'react';
import { ProjectAPI } from '@brg/api';
export var useGetProjectListByIds = function (ids) {
    var _a = useState(null), projects = _a[0], setProjects = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!ids || (ids === null || ids === void 0 ? void 0 : ids.length) === 0) {
            setProjects([]);
            return;
        }
        setLoading(true);
        ProjectAPI.GetList({
            projectIds: ids,
            isLite: true,
            isContextIgnored: true,
            appNameIgnore: true,
            projectFilter: 2,
            projectStatus: [1, 7, 9, 10],
            orderByProjectIds: true
        })
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setProjects((r === null || r === void 0 ? void 0 : r.data) || null);
            setLoading(false);
        })
            .catch(function (error) {
            console.error(error);
            setError(true);
            setLoading(false);
        });
    }, [ids]);
    return {
        projects: projects,
        loading: loading,
        error: error
    };
};
//# sourceMappingURL=useGetProjectListByIds.js.mapimport { useEffect, useState } from 'react';
import { ProjectAPI } from '@brg/api';
export var useGetProjectListByIds = function (ids) {
    var _a = useState(null), projects = _a[0], setProjects = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!ids || (ids === null || ids === void 0 ? void 0 : ids.length) === 0) {
            setProjects([]);
            return;
        }
        setLoading(true);
        ProjectAPI.GetList({
            projectIds: ids,
            isLite: true,
            isContextIgnored: true,
            appNameIgnore: true,
            projectFilter: 2,
            projectStatus: [1, 7, 9, 10],
            orderByProjectIds: true
        })
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setProjects((r === null || r === void 0 ? void 0 : r.data) || null);
            setLoading(false);
        })
            .catch(function (error) {
            console.error(error);
            setError(true);
            setLoading(false);
        });
    }, [ids]);
    return {
        projects: projects,
        loading: loading,
        error: error
    };
};
//# sourceMappingURL=useGetProjectListByIds.js.map